import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const buyers = [{
  name: 'María G.',
  city: 'Ciudad de México',
  time: 'hace 2 min'
}, {
  name: 'Carolina R.',
  city: 'Bogotá, Colombia',
  time: 'hace 5 min'
}, {
  name: 'Lucía P.',
  city: 'Lima, Perú',
  time: 'hace 3 min'
}, {
  name: 'Ana M.',
  city: 'Buenos Aires, Argentina',
  time: 'hace 1 min'
}, {
  name: 'Valentina S.',
  city: 'Santiago, Chile',
  time: 'hace 4 min'
}, {
  name: 'Gabriela T.',
  city: 'Quito, Ecuador',
  time: 'hace 2 min'
}, {
  name: 'Sofía L.',
  city: 'Guadalajara, México',
  time: 'hace 6 min'
}, {
  name: 'Daniela F.',
  city: 'Medellín, Colombia',
  time: 'hace 1 min'
}, {
  name: 'Camila H.',
  city: 'Monterrey, México',
  time: 'hace 3 min'
}, {
  name: 'Isabella V.',
  city: 'San José, Costa Rica',
  time: 'hace 5 min'
}, {
  name: 'Fernanda D.',
  city: 'Caracas, Venezuela',
  time: 'hace 2 min'
}, {
  name: 'Andrea B.',
  city: 'Panamá City, Panamá',
  time: 'hace 4 min'
}, {
  name: 'Paula N.',
  city: 'Santo Domingo, RD',
  time: 'hace 1 min'
}, {
  name: 'Mariana C.',
  city: 'Tegucigalpa, Honduras',
  time: 'hace 3 min'
}, {
  name: 'Alejandra O.',
  city: 'La Paz, Bolivia',
  time: 'hace 6 min'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const showInterval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    }, 9000);
    // Show first one after 9 seconds
    const initialTimeout = setTimeout(() => {
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    }, 9000);
    return () => {
      clearInterval(showInterval);
      clearTimeout(initialTimeout);
    };
  }, []);
  const buyer = buyers[currentIndex];
  return <div className="fixed bottom-4 left-4 z-[90]" data-id="element-219">
      <AnimatePresence data-id="element-220">
        {visible && <motion.div initial={{
        opacity: 0,
        x: -100,
        y: 20
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -100
      }} transition={{
        type: 'spring',
        damping: 20,
        stiffness: 300
      }} className="bg-white rounded-xl shadow-lg border border-gold/20 p-4 flex items-center gap-3 max-w-xs" data-id="element-221">
            <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center shrink-0" data-id="element-222">
              <ShoppingBag className="w-5 h-5 text-rose-600" data-id="element-223" />
            </div>
            <div data-id="element-224">
              <p className="text-sm font-bold text-chocolate leading-tight" data-id="element-225">
                {buyer.name}
              </p>
              <p className="text-xs text-chocolate-light" data-id="element-226">
                Se unió al programa desde{' '}
                <span className="font-medium" data-id="element-227">{buyer.city}</span>
              </p>
              <p className="text-xs text-rose-500 font-medium mt-0.5" data-id="element-228">
                {buyer.time}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}